import { setLastVerification } from '../utils/initialize';

import { SET_LAST_VERIFICATION_DATE, SET_VERIFICATION_ERROR } from '../constants';

const initialState = setLastVerification();

const lastVerification = (state = initialState, action) => {
  switch (action.type) {
    case SET_LAST_VERIFICATION_DATE:
      return {
        date: action.payload.date,
        error: undefined,
      };
    case SET_VERIFICATION_ERROR:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default lastVerification;



// WEBPACK FOOTER //
// ./src/reducers/lastVerification.js